import * as notificationSlice from './notificationSlice';
import * as selectors from './selectors';

export const reducers = {
  notification: notificationSlice.notificationSlice.reducer,
};

export { notificationSlice, selectors };
